import { render, staticRenderFns } from "./tree-edit.vue?vue&type=template&id=c76a1de4&scoped=true"
import script from "./tree-edit.vue?vue&type=script&lang=js"
export * from "./tree-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a1de4",
  null
  
)

export default component.exports